
export function _checkStrings(string) {
    if (string === undefined || string === null) {
        string = "";
    }
    return string;
}
